/* RAYZ section rail: a quiet index on the right edge of the homepage. Up/down and the ticks cut straight
   to a chapter behind a brief ivory veil, so the scenes in between are skipped rather than replayed. */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const extra = { explore_looks: 'Looks', reels: 'Reels' };

  function chapters() {
    const list = [...document.querySelectorAll('[data-rz-rail]')].map((el) => ({ el, label: el.dataset.rzRail }));
    document.querySelectorAll('main > .shopify-section').forEach((s) => {
      const key = Object.keys(extra).find((k) => s.id.endsWith('__' + k));
      if (key && s.offsetHeight > 0) list.push({ el: s, label: extra[key] });
    });
    return list.sort((a, b) => (a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
  }

  let items = [], rail, veil, cur = -1, busy = false;
  const top = (el) => el.getBoundingClientRect().top + scrollY;
  const pad = (n) => String(n).padStart(2, '0');

  function build() {
    if (rail) rail.remove();
    rail = null; cur = -1;
    items = chapters();
    if (items.length < 3) return;
    rail = document.createElement('nav');
    rail.className = 'rz rz-rail';
    rail.setAttribute('aria-label', 'Chapters');
    rail.innerHTML = `<button type="button" class="rz-rail-step" data-step="-1" aria-label="Previous chapter"><i></i></button>
      <ol>${items.map((it, i) => `<li><button type="button" data-i="${i}" aria-label="Go to ${it.label}"><span class="rz-rail-n">${pad(i + 1)}</span><span class="rz-rail-l">${it.label}</span><i></i></button></li>`).join('')}</ol>
      <button type="button" class="rz-rail-step is-down" data-step="1" aria-label="Next chapter"><i></i></button>`;
    document.body.appendChild(rail);
    if (!veil) { veil = document.createElement('div'); veil.className = 'rz-veil'; veil.setAttribute('aria-hidden', 'true'); document.body.appendChild(veil); }
    rail.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      if (b.dataset.i) go(+b.dataset.i);
      else go(Math.max(0, Math.min(items.length - 1, cur + +b.dataset.step)));
    });
  }

  function go(i) {
    if (busy || !items[i]) return;
    const target = top(items[i].el);
    const lenis = window.RayzScroll && RayzScroll.lenis;
    const jump = () => { if (lenis) lenis.scrollTo(target, { immediate: true, force: true }); else scrollTo({ top: target, behavior: 'instant' }); };
    if (reduce || Math.abs(target - scrollY) < innerHeight * 0.6) { if (lenis && !reduce) lenis.scrollTo(target, { duration: 1.1 }); else jump(); return; }
    busy = true;
    document.documentElement.classList.add('rz-veiled');
    setTimeout(() => {
      jump();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        document.documentElement.classList.remove('rz-veiled');
        setTimeout(() => { busy = false; }, 500);
      }));
    }, 380);
  }

  function track() {
    if (rail) {
      const mid = scrollY + innerHeight * 0.45;
      let idx = 0;
      items.forEach((it, i) => { if (top(it.el) <= mid) idx = i; });
      if (idx !== cur) {
        cur = idx;
        rail.querySelectorAll('li').forEach((li, i) => li.classList.toggle('is-on', i === idx));
        rail.querySelector('[data-step="-1"]').disabled = idx === 0;
        rail.querySelector('[data-step="1"]').disabled = idx === items.length - 1;
      }
      const hdr = document.querySelector('.rz-hdr'), lb = document.querySelector('.rz-lb');
      const lbMid = lb && (() => { const r = lb.getBoundingClientRect(); return r.top < innerHeight * 0.5 && r.bottom > innerHeight * 0.5; })();
      rail.classList.toggle('is-light', !!(hdr && hdr.classList.contains('is-light') && !hdr.classList.contains('is-solid')) || !!lbMid);
    }
    requestAnimationFrame(track);
  }
  const start = () => { build(); requestAnimationFrame(track); };
  if (document.readyState === 'complete') start(); else addEventListener('load', start);
  document.addEventListener('shopify:section:load', build);
  document.addEventListener('shopify:section:unload', () => setTimeout(build));
})();
